"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HeaderMenuCategory = _interopRequireWildcard(require("../HeaderMenuCategory"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HeaderMenuWishlist = function HeaderMenuWishlist(props) {
  var name = props.name,
    slug = props.slug,
    onToggleWishlist = props.onToggleWishlist,
    _props$counter = props.counter,
    counter = _props$counter === void 0 ? '1' : _props$counter,
    children = props.children,
    isCompact = props.isCompact,
    breakpoint = props.breakpoint;
  return /*#__PURE__*/_react["default"].createElement(CategoryWishlist, {
    isCompact: isCompact,
    name: name,
    slug: slug,
    counter: counter,
    onClick: onToggleWishlist,
    breakpoint: breakpoint
  }, /*#__PURE__*/_react["default"].createElement(StyledNestedMenu, {
    hasItems: counter
  }, children));
};
var CategoryWishlist = (0, _styledComponents["default"])(_HeaderMenuCategory["default"]).withConfig({
  displayName: "HeaderMenuWishlist__CategoryWishlist",
  componentId: "sc-jq8hfi-0"
})(["&:hover{background-color:#fff;border-radius:3px 3px 0 0;& > div > svg{stroke:#000;}", "{color:#000;}", "{cursor:pointer;}&::after{background:#000;color:#fff;}}&::after{", " cursor:pointer;position:absolute;width:16px;height:16px;font-size:12px;font-weight:bold;letter-spacing:1px;background:#fff;border-radius:50%;top:1px;right:20px;color:#000;display:flex;align-items:center;justify-content:center;padding-bottom:1px;}"], _HeaderMenuCategory.CategoryName, _HeaderMenuCategory.IconWrapper, function (_ref) {
  var counter = _ref.counter;
  return counter && "\n      content: '".concat(counter, "';\n    ");
});
var StyledNestedMenu = (0, _styledComponents["default"])(_HeaderMenuCategory.NestedMenu).attrs({
  as: 'div'
}).withConfig({
  displayName: "HeaderMenuWishlist__StyledNestedMenu",
  componentId: "sc-jq8hfi-1"
})(["color:#000;box-shadow:0 3px 5px rgba(0,0,0,0.2);border-radius:3px 0 3px 3px;background-color:#fff;right:0;left:auto;padding-bottom:0;width:", ";"], function (props) {
  return props.hasItems ? '500px' : '350px';
});
var _default = exports["default"] = HeaderMenuWishlist;